module.exports = __webpack_public_path__ + "static/media/11_r_woll_80.21_0.b49ed0a9.png";